import { render, staticRenderFns } from "./Team2.vue?vue&type=template&id=ef29bafc&"
import script from "./Team2.vue?vue&type=script&lang=js&"
export * from "./Team2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports